var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardYellow32Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "24px",
    viewBox: "0 0 32 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E0F6E0DF-25FB-4C1F-B747-0E3D656E5315_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Reklaam",
    transform: "translate(-208.000000, -360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(208.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Card_Yellow-32px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2,0 L28.8,0 C30.567312,0 32,1.53502286 32,3.42857143 L32,20.5714286 C32,22.4649771 30.567312,24 28.8,24 L3.2,24 C1.432688,24 0,22.4649771 0,20.5714286 L0,3.42857143 C0,1.53502286 1.432688,0 3.2,0 Z",
    id: "Fill-1",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#000000",
    points: "0 5.14285714 32 5.14285714 32 10.2857143 0 10.2857143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,15.4285714 L27.2,15.4285714 C28.083648,15.4285714 28.8,16.1960829 28.8,17.1428571 C28.8,18.0896314 28.083648,18.8571429 27.2,18.8571429 L24,18.8571429 C23.116352,18.8571429 22.4,18.0896314 22.4,17.1428571 C22.4,16.1960829 23.116352,15.4285714 24,15.4285714 Z",
    id: "Fill-5",
    fillOpacity: 0.3,
    fill: "#000000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardYellow32Px);
export default __webpack_public_path__ + "static/media/Icon_Card_Yellow-32px.7c9bf38636cb8d8e6ebe5452c1557d61.svg";
export { ForwardRef as ReactComponent };